// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar--S0ashf9NJL","light":"light--Bvi6l6hQO1","dark":"dark--TOdA+DUs1z","controls":"controls--NctgvZTU2f","icons":"icons--DuTBbkeFt6","icon":"icon--oWUnqRUEMW"};